export function getStepName(step: number): 'brand' | 'product' | 'condition' | 'instructions' {
  const stepName: Array<'brand' | 'product' | 'condition' | 'instructions'> = [
    'brand',
    'product',
    'condition',
    'instructions'
  ];

  return stepName[step];
}

export function getNavigationButtonTrackingParams(
  currentStep: number,
  direction: 'next' | 'previous'
) {
  return {
    sub_feature: getStepName(currentStep),
    index: 1,
    total_indices: 1,
    direction
  };
}
